import React,{forwardRef,useState,} from 'react'
import { Card, CardContent, Typography } from '@material-ui/core'
import "./Message.css"

 const WrappedComponent = React.forwardRef(
    function Message  ({message,username},ref)  {
        // const ref = React.createRef();
    
        const isUser = username === message.username;
        // const [isUser] = useState(username === message.username)
         return (
            <div ref={ref} className= {`message_card ${isUser && 'message_user'}`}>
            <Card
             className={isUser ? 'message_userCard' : "message_guestCard"} >
                <CardContent>
                    <Typography
                    color="white"
                    variant="h5"
                    component="h2"
                    >
                    { !isUser && `${message.username || 'Unknown User'}: `}  {message.message}
                    </Typography>
                </CardContent>
            </Card>
            </div>
    )
       }
 )
 


   export default WrappedComponent
   
    
// import React from 'react'

//  const Message =  ({message,username}) =>  {
//     return (
//         <div>
//             <h1> {message.username}:   {message.message}</h1>
//         </div>
//     )
// }

// export default Message


